import React from 'react'
import { useRecoilValue } from 'recoil'
import { Box, Text, CardDetails, CardRow } from '@/presentation/components'
import { DateAdapter } from '@/data/protocols'
import { serviceOrderDetailState } from '@/presentation/pages/ServiceOrderDetail/components'
import { styles } from '../../styles'

type OsInfoProps = {
  dateAdapter: DateAdapter
}

export const OsInfo: React.FC<OsInfoProps> = ({
  dateAdapter
}) => {
  const serviceOrderDetail = useRecoilValue(serviceOrderDetailState)

  const validaDataZerada = (stringValue: string): string => {
    return stringValue === '01/01/0001 12:00:00' ? '' : stringValue
  }

  return (
  <>
    <Text style={styles.pageInfo}>Informações da OS</Text>
    <CardRow>
      <CardDetails minWidth={600}>
        <Box style={styles.titleBox}>
          <Text style={styles.bold}>Origem</Text>
        </Box>
        <Text><span style={styles.bold}>Empresa: </span>{serviceOrderDetail.empresa}</Text>
        <Text><span style={styles.bold}>Orçamento: </span>{serviceOrderDetail.orcamento}</Text>
        <Text><span style={styles.bold}>Vendedor: </span>{serviceOrderDetail.nomeVendedor}</Text>
        <Box style={styles.additionalTextBox}>
          <Text><span style={styles.bold}>Solicitante: </span>{serviceOrderDetail.solicitante}</Text>
        </Box>
      </CardDetails>
      <CardDetails minWidth={600}>
        <Box style={styles.titleBox}>
          <Text style={styles.bold}>Planejamento</Text>
        </Box>
        <Text><span style={styles.bold}>OS com data agendada? </span>{serviceOrderDetail.agendada ? 'SIM' : 'NÃO'}</Text>
        {serviceOrderDetail.agendada &&
          <>
            <Text><span style={styles.bold}>Data agendada: </span>{dateAdapter.format(serviceOrderDetail.dataAgenda, 'DD/MM/yyyy hh:mm:ss')}</Text>
            <Text><span style={styles.bold}>Conclusão: </span>{dateAdapter.format(serviceOrderDetail.previsao, 'DD/MM/yyyy hh:mm:ss')}</Text>
          </>
        }
        <Box style={styles.additionalTextBox}>
          <Text><span style={styles.bold}>Data para entrega: </span>{dateAdapter.format(serviceOrderDetail.previsao, 'DD/MM/yyyy')}</Text>
        </Box>
      </CardDetails>

      <CardDetails minWidth={600}>
        <Box style={styles.titleBox}>
          <Text style={styles.bold}>Abertura</Text>
        </Box>
        <Text><span style={styles.bold}>Data da abertura: </span>{dateAdapter.format(serviceOrderDetail.abertura, 'DD/MM/yyyy hh:mm:ss')}</Text>
        <Text><span style={styles.bold}>Causa da OS: </span>{serviceOrderDetail.causaOS}</Text>
        <Text><span style={styles.bold}>Defeito apontado: </span>{serviceOrderDetail.defeito}</Text>
        <Box style={styles.additionalTextBox}>
          <Text><span style={styles.bold}>Aberta por: </span>{serviceOrderDetail.usuarioAbertura}</Text>
        </Box>
      </CardDetails>
      <CardDetails minWidth={600}>
        <Box style={styles.titleBox}>
          <Text style={styles.bold}>Execução</Text>
        </Box>
        <Text><span style={styles.bold}>Técnico: </span>{serviceOrderDetail.nomeTecnico}</Text>
        <Text><span style={styles.bold}>Gerente técnico: </span>{serviceOrderDetail.nomeGetec}</Text>
        <Text><span style={styles.bold}>Veículo: </span>{serviceOrderDetail.veiculoOS}</Text>
      </CardDetails>

      <CardDetails minWidth={600}>
        <Box style={styles.titleBox}>
          <Text style={styles.bold}>Fechamento</Text>
        </Box>
        <Text><span style={styles.bold}>Data de fechamento: </span>{validaDataZerada(dateAdapter.format(serviceOrderDetail.dataFechamento, 'DD/MM/yyyy hh:mm:ss'))}</Text>
        <Text><span style={styles.bold}>Solução: </span>{serviceOrderDetail.solucaoOS}</Text>
        <Box style={styles.additionalTextBox}>
          <Text><span style={styles.bold}>Fechada por: </span>{serviceOrderDetail.usuarioFechamento}</Text>
        </Box>
      </CardDetails>
      <CardDetails minWidth={600}>
        <Box style={styles.titleBox}>
          <Text style={styles.bold}>Faturamento</Text>
        </Box>
        <Text>
        <span style={styles.bold}>Nota de locação: </span>{serviceOrderDetail.notaLocacao}
        <span style={styles.bold}> Data de emissão: </span>{validaDataZerada(dateAdapter.format(serviceOrderDetail.dataEmissao, 'DD/MM/yyyy hh:mm:ss'))}
        </Text>
      </CardDetails>
    </CardRow>
    <CardRow>
      <CardDetails>
        <Box style={styles.titleBox}>
          <Text style={styles.bold}>Observações de Abertura</Text>
        </Box>
        <Text>{serviceOrderDetail.executar}</Text>
      </CardDetails>
      <CardDetails>
        <Box style={styles.titleBox}>
          <Text style={styles.bold}>Observações Internas</Text>
        </Box>
        <Text>{serviceOrderDetail.observacaoInterna}</Text>
      </CardDetails>
      <CardDetails>
        <Box style={styles.titleBox}>
          <Text style={styles.bold}>Observações de Fechamento</Text>
        </Box>
        <Text>{serviceOrderDetail.obsFechamento}</Text>
      </CardDetails>
    </CardRow>
  </>
  )
}
